import "./index.scss";
export default function Loading({ className }: { className?: string }) {
  return (
    <div className={`loading-component loading`}>
      <div className={"ring"}></div>
    </div>
  );
}
